import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import hasPermissions from '../../../utilities/hasPermissions';
import useGoTo from '../../../utilities/useGoTo';
import BannerList from './BannerList';

const BannerListPage = () => {
    const { t } = useTranslation(['bannerList']);
    const { permissions: accountPermissions } = useAccount();

    const addBanner = useGoTo('/admin/banners/add');
    const extra = hasPermissions(accountPermissions, [permissionKind.createBanner]) && (
        <Button icon={<PlusOutlined />} onClick={addBanner} type="primary">
            {t('bannerList:actions.addBanner')}
        </Button>
    );

    return (
        <ConsolePageWithHeader extra={extra} title={t('bannerList:title')}>
            <BannerList />
        </ConsolePageWithHeader>
    );
};

export default BannerListPage;
